module.exports = __webpack_public_path__ + "img/114.aff2a83e.jpg";